import { FC } from 'react';

import * as yup from 'yup';
import styled from '@emotion/styled';
import { DateTime } from 'luxon';
import { useFormik } from 'formik';

import { Button, IcoCross } from '@britishcouncil/react-solas';
import { TextField } from '@britishcouncil/react-solas-ors3';
import { useFormFields } from '@britishcouncil/react-forms';

const VALIDATION_SCHEMA = yup.object().shape({
  systemDate: yup
    .string()
    .required('Invalid date')
    .test(
      'valid-date',
      'Invalid date',
      (value) => DateTime.fromFormat(value || '', 'dd/MM/yyyy').isValid
    ),
});

export const SystemTimeForm: FC<{
  systemDate: string;
  isSubmitting?: boolean;
  isResetInProgress?: boolean;
  onSubmit: (value: string) => void;
  onReset: () => void;
  onClose: () => void;
}> = ({
  systemDate,
  isSubmitting,
  isResetInProgress,
  onSubmit,
  onReset,
  onClose,
}) => {
  const formik = useFormik({
    initialValues: { systemDate },
    enableReinitialize: true,
    validationSchema: VALIDATION_SCHEMA,
    onSubmit: (values) => onSubmit(values.systemDate),
  });

  const fields = useFormFields(formik);

  return (
    <>
      <p>
        Current system date (visible only for test environments):
        <IcoCross onClick={onClose} />
      </p>
      <FlexBox>
        <TextField {...fields.systemDate} />
        <Button
          size="xs"
          square
          intent="primary"
          type="button"
          loading={isSubmitting}
          onClick={formik.submitForm}
          disabled={!formik.isValid}
        >
          Set Date
        </Button>
        <Button
          size="xs"
          square
          intent="primary"
          type="button"
          loading={isResetInProgress}
          onClick={onReset}
        >
          Reset
        </Button>
      </FlexBox>
    </>
  );
};

const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: start;
  justify-content: center;
  gap: 10px;
`;
